export default {
  title: 'Nimeä tarjous uudelleen',
  subtitle: 'Anna tarjouksellesi uusi nimi (enintään 40 merkkiä)',
  toasts: {
    success: 'Tarjous nimettiin uudelleen onnistuneesti',
    error: 'Tarjouksen uudelleennimeäminen epäonnistui',
  },
  buttons: {
    rename: 'Nimeä uudelleen',
  },
  form: {
    title: {
      label: 'Tarjouksen nimi',
      placeholder: 'Anna tarjouksen nimi',
    },
  },
};
